<div
  modalEscape
  (escape)="closeWithSlideOut()"
  class="content rv-rows slide-in"
  [class.content-border]="!modalScrim"
  [style.width]="width"
  [style.min-width]="width"
>
  <div
    class="rv-flex"
    [ngClass]="
      sideModalBorder
        ? 'side-modal-header-border'
        : 'side-modal-header-no-border'
    "
  >
    <h5 class="rv-title-02">{{ title }}</h5>
    <ng-content select="[slot=header-extras]"></ng-content>
    <button
      rivButton
      [variant]="'ghost'"
      [size]="'large'"
      class="close"
      title="Close"
      [rivTooltip]="'Close'"
      type="button"
      (click)="$event.preventDefault(); closeWithSlideOut()"
      [icon]="'X'"
    ></button>
  </div>
  <ng-content></ng-content>
</div>
